import { useAuth } from "./useAuth";
import { useChallenges } from "./useChallenges";
import { useAdmin } from "./useAdmin";

/**
 * Compositor principal de estado.
 * Não contém lógica — apenas compõe os hooks especializados
 * e expõe tudo via uma única interface para o App.jsx.
 */
export function useAppState() {
  const auth = useAuth();

  const challenges = useChallenges({
    state: auth.state,
    save: auth.save,
    currentUser: auth.currentUser,
    flash: auth.flash,
    gender: auth.gender,
  });

  const admin = useAdmin({
    state: auth.state,
    save: auth.save,
    flash: auth.flash,
    gender: auth.gender,
  });

  // valor derivado: jogador logado
  const me = auth.state && auth.currentUser !== "admin"
    ? auth.state.players.find(p => p.id === auth.currentUser)
    : null;

  // allChallenges: M + F combinados, já retornados pelo dbLoadState
  const allChallenges = auth.state?.allChallenges || [];

  return {
    ...auth,
    ...challenges,
    ...admin,
    me,
    allChallenges,
  };
}
